type ShareLinksProps = {
  /** 共有するページの URL とタイトル */
  url: string
  title: string
}

/** Facebook / X / LINE は Figma 上もビットマップのため webp を使う */
const toShareLinks = ({ url, title }: ShareLinksProps) => {
  const encodedUrl = encodeURIComponent(url)
  const encodedTitle = encodeURIComponent(title)

  return [
    {
      icon: 'icon-fb',
      alt: 'Facebookで共有',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
    },
    {
      icon: 'icon-x',
      alt: 'Xで共有',
      href: `https://twitter.com/share?text=${encodedTitle}&url=${encodedUrl}`
    },
    {
      icon: 'icon-line',
      alt: 'LINEで共有',
      href: `https://social-plugins.line.me/lineit/share?url=${encodedUrl}`
    }
  ]
}

/**
 * SNS 共有（Facebook / X / LINE / メール）の 40px アイコン列。Figma: col/SNS。
 * 上下 20 の余白は Figma と同じくこの部品が持つ。コラムの右カラムと記事の上下で使う。
 */
export function ShareLinks({ url, title }: ShareLinksProps) {
  return (
    <ul
      aria-label="このページを共有"
      className="flex items-center justify-center gap-4 py-5"
    >
      {toShareLinks({ url, title }).map((link) => (
        <li key={link.icon}>
          <a
            href={link.href}
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="block size-10 transition-opacity hover:opacity-80"
          >
            <img
              src={`/images/icons/${link.icon}.webp`}
              srcSet={`/images/icons/${link.icon}.webp 1x, /images/icons/${link.icon}@2x.webp 2x`}
              alt={link.alt}
              width={40}
              height={40}
              className="size-10"
            />
          </a>
        </li>
      ))}
      <li>
        <a
          href={`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`}
          className="flex size-10 text-ink transition-opacity hover:opacity-80"
        >
          <span aria-hidden="true" className="icon icon-mail size-10" />
          <span className="sr-only">メールで共有</span>
        </a>
      </li>
    </ul>
  )
}
